const mobileCatalogue = window.matchMedia('(max-width: 989px)');

function setupCatalogueDisclosures(scope = document) {
  scope.querySelectorAll('[data-collection-disclosure]').forEach((details) => {
    if (details.dataset.catalogueReady) return;
    details.dataset.catalogueReady = 'true';
    details.open = !mobileCatalogue.matches;
  });
}

setupCatalogueDisclosures();
mobileCatalogue.addEventListener('change', () => {
  document.querySelectorAll('[data-collection-disclosure]').forEach((details) => {
    details.open = !mobileCatalogue.matches;
  });
});
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-collection-category-select]');
  if (!select?.value) return;
  const destination = new URL(select.value, window.location.origin);
  if (destination.origin !== window.location.origin || !destination.pathname.includes('/collections/')) return;
  window.location.assign(destination.href);
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const disclosure = event.target.closest('[data-collection-disclosure][open]');
  if (!disclosure) return;
  disclosure.open = false;
  disclosure.querySelector('summary')?.focus();
});
document.addEventListener('shopify:section:load', () => setupCatalogueDisclosures());
const catalogueObserver = new MutationObserver(() => setupCatalogueDisclosures());
document.querySelectorAll('results-list.star-ux-catalogue').forEach((list) => {
  catalogueObserver.observe(list, { childList: true, subtree: true });
});
